import React from 'react'
import { Helmet } from 'react-helmet'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import { timeRestrictionsSettings } from '../../constants/settings_constants'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import PricingDetails from './pricing_details'
import PropTypes from 'prop-types'
import SelectInput from '../input/select'

const PricingEditForm = ({ state }) => {
  const entity = state.cv.record
  const pricings = entity.has('pricings') && entity.get('pricings')
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.FP_PRICING, 'w')
  const entityRestriction = timeRestrictionsSettings[state.cv.timeRestriction].valid_from.restriction
  const disabledIfRunning = pricings && pricings.find(v => entityRestriction.isSameOrAfter(v.valid_from, 'day'))

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_PRICING_TITLE).concat(defaultConst.HTML_DIVIDER) + (entity.has('id')
        ? (entity.get('id') ? 'ID ' + entity.get('id') : state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />
      <div className='col-lg-12'>
        <div className='row'>
          <div className='col-sm-12 col-lg-4'>
            <SelectInput
              label={state.__('platform')}
              attr={'platform'}
              record={entity}
              labelattr='text'
              valueattr='value'
              onChange={updateField}
              optionsrecord={state.options}
              optionsattr={'FlyPrivatePlatforms'}
              errors={errors} disabled={disabled || disabledIfRunning} />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectInput
              label={state.__('tier')}
              attr={'tier'}
              record={entity}
              labelattr='text'
              valueattr='value'
              onChange={updateField}
              optionsrecord={state.options}
              optionsattr={'PricingTiers'}
              errors={errors} disabled={disabled || disabledIfRunning} />
          </div>
          <div className='col-sm-12 col-lg-4'>
            <SelectInput
              label={state.__('sale type')}
              attr={'type_sale'}
              record={entity}
              labelattr='text'
              valueattr='value'
              onChange={updateField}
              optionsrecord={state.options}
              optionsattr={'VodSaleTypes'}
              errors={errors} disabled={disabled || disabledIfRunning} />
          </div>
        </div>
        <PricingDetails
          store={state} />
      </div >
    </div >
  )
}
PricingEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const PricingEditView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.FP_PRICING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.FP_PRICING, 'w')} >
      <PricingEditForm state={store} />
    </EditView>
  )
}
export default PricingEditView
